import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { QueryKey } from '@tanstack/react-query'
import { useFarmContext } from 'src/Elements/Farm'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { getWallboxHardwareBulk } from '../api/wallbox-hardware.api'
import { isFlowTheme } from 'src/Libs/utils'
import { usePortalQuery } from 'src/Libs/api'

type UseWallboxHardwareBulkQuery = {
  data: WallboxHardwareModel[] | null
  isLoading: boolean
  isError: boolean
}

export const getWallboxHardwareBulkQueryKey = (storageIds: string[]): QueryKey => ['wallbox-hardware-bulk', ...storageIds]

const useWallboxHardwareBulkQuery = (enabled = true): UseWallboxHardwareBulkQuery => {
  const { isFarm, isFarmMasterSelected, farmMaster, farmClients, isLoading: isFarmLoading } = useFarmContext()
  const authFetch = useAuthFetchWithResponse()

  const storageIdsOnlyClients = isFarmMasterSelected ? farmClients?.map(client => client.storageId) || [] : []

  // Flow sub-devices are linked also to the farm master , not just the clients.
  const storageIdsOnlyFarmMaster = isFarmMasterSelected && farmMaster?.storageId ? [farmMaster.storageId] : []
  const storageIds = isFlowTheme ? [...storageIdsOnlyClients, ...storageIdsOnlyFarmMaster] : storageIdsOnlyClients
  const { data, isLoading, isError } = usePortalQuery({
    queryKey: getWallboxHardwareBulkQueryKey(storageIds),
    queryFn: () => getWallboxHardwareBulk(storageIds, authFetch),
    enabled: enabled && storageIds.length > 0 && isFarm && farmClients && !isFarmLoading && isFarmMasterSelected,
  })

  return {
    data: data || null,
    isLoading,
    isError,
  }
}

export default useWallboxHardwareBulkQuery
